"use client";

import { ReferralSource, getLeadSourceCookie } from "@/app/lib/actions/referrer";
import { useEffect, useState } from "react";
export function useLeadSource() {
  const [leadSource, setLeadSource] = useState<ReferralSource | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const fetchLeadSource = async () => {
      try {
        const cookie = await getLeadSourceCookie();
        setLeadSource(cookie);
      } catch (error) {
        console.error("Error fetching lead source", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchLeadSource();
    const interval = setInterval(fetchLeadSource, 30 * 1000); // Refresh every 30 seconds

    return () => clearInterval(interval);
  }, []);
  return {
    leadSource,
    isLoading,
    isUtm: leadSource?.type === "utm",
    isReferral: leadSource?.type === "referrer",
    isDirect: leadSource?.type === "direct",
    getUtmParam: (param: "source" | "medium" | "campaign" | "content" | "term") => leadSource?.type === "utm" ? leadSource[param] : null,
    timeSinceFirstVisit: leadSource ? Math.floor((Date.now() - leadSource.timestamp) / 1000) : null
  };
}